import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ArrowTabsTitle } from "../../../../Constants/Constants";
import { ArrowTabsSubTitle } from "../../../../Data/UiKits/Tabs";
import ArrowTabsNav from "./ArrowTabsNav";
import ArrowTabsNavContent from "./ArrowTabsNavContent";

const ArrowTabs = () => {
  const [basicTab, setBasicTab] = useState("2");

  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={ArrowTabsTitle} span={ArrowTabsSubTitle} />
        <CardBody className="bg-navbar arrow-tabs">
          <ArrowTabsNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <ArrowTabsNavContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ArrowTabs;
